<svg viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M1 14.443l2.965-2.964h10.372a.664.664 0 0 0 .663-.664V1.663A.664.664 0 0 0 14.337 1H1.663A.664.664 0 0 0 1 1.663v12.78zm3.38-1.964L1.036 15.82A.607.607 0 0 1 0 15.39V1.664C0 .745.745 0 1.663 0h12.674C15.255 0 16 .745 16 1.663v9.152c0 .919-.745 1.664-1.663 1.664H4.379zM9 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>
